import React from 'react'
import SimpleModal from '@modules/admin/common/modal/simpleModal'
import TextField from '@modules/admin/common/fields/textField'
import Table from '@modules/admin/common/table'
import CustomPagination from '@modules/tableComponents/Pagination'
import { useRequestOld } from '@/hooks'
import { createAsociatedCustomersColumns, createAsociatedCustomersRows } from '@modules/admin/groups/actions'
import { closeModal, triggerModal } from '@utilities/modal'
import { CONFIRM_CLASS } from '@modules/admin/groups/constants'
import { RemoveModal } from '@modules/admin/groups/template'
import Consultations from '@services/Consultations'
import Loading from '@modules/core/components/Loading'

const UserGroupsModal = ({ hide, client, title, className, isDefaultGroup, t }) => {
  const { data, loading, search, setSearch, pagination, fetch } = useRequestOld(client)
  const columns = createAsociatedCustomersColumns({ isDefaultGroup, t })
  const rows = createAsociatedCustomersRows

  const manageTextRemoveModal = (item) => {
    const { firstname, lastname } = item
    return (
      <>
        <label>{t('removeUserGroupModalText1', { userName: `${firstname} ${lastname}` })}</label>
        <div>{t('removeUserGroupModalText2')}</div>
      </>
    )
  }
  const removeUser = async ({ hash }) => {
    //todo: añadir la petición para eliminar el usuario
    try {
      await Consultations.userGroups.removeUserFromGroup(hash)
    } catch (e) {
      console.error(e.message)
    }
    closeModal(CONFIRM_CLASS)
    await fetch()
  }
  const confirmAssociatedModal = (item) => (
    <RemoveModal
      hide={() => closeModal(CONFIRM_CLASS)}
      text={manageTextRemoveModal(item)}
      t={t}
      className="tight"
      confirmFn={() => removeUser(item)}
    />
  )
  const onDelete = (item) => triggerModal(confirmAssociatedModal(item), CONFIRM_CLASS)
  return (
    <SimpleModal
      title={title}
      hideModal={hide}
      loading={false}
      className={className}
      template={
        <>
          {loading ? (
            <Loading isFetching={true} />
          ) : (
            <>
              <TextField placeholder={'text'} value={search} onChange={(e) => setSearch(e.target?.value)} />
              <Table columns={columns} rows={rows({ columns, rows: data, onDelete })} />
              <CustomPagination
                onClickItem={(page) => fetch(page)}
                activePage={pagination.currentPage}
                totalPages={pagination.lastPage}
                maxButtons={7}
              />
            </>
          )}
        </>
      }
    />
  )
}
export default UserGroupsModal
